import Cookies from 'js-cookie';
import { RELIC_ACTION_TYPES_NAME, RELIC_EVENT_NAME, NI_C_COOKIES } from "../constants";

/**
 * @name addRelicAnalyticsPageAction
 * @description - Reports event along with a name and optional attributes
 * @param {string | undefined} name - Event name
 * @param {object} args - Event data object
 * @param {string} args.translations - User type
 * @param {string} args.view_type - View type
 * @param {string} args.consent - Users consent
 * @param {string} args.geolocation - Geo location of user
 * @param {string} args.gpc_enabled - GPC enabled status
 * @param {string} args.error_message - Network response error message
 * @param {string} args.api_url - Network response API URL
 * @param {string} args.response_body - Network response body
 * @param {Promise<string | undefined>} args.registeredCountry - Users registered country
 * @returns {void}
 */
export const addRelicAnalyticsPageAction = (name, args) => {
  try {
    var _window$newrelic;
    // name is a required field for this New Relic function, if we don't have it,
    // then don't even attempt to hit the New Relic library.
    if (!name) return;
    if ((_window$newrelic = window.newrelic) !== null && _window$newrelic !== void 0 && _window$newrelic.addPageAction) window.newrelic.addPageAction(name, args);
    /* eslint-disable no-empty */
  } catch (err) {}
};

/**
 * @name getRelicUserType
 * @description - Returns user type for Relic events
 * @param {boolean} isLoggedIn - Is user logged in boolean
 * @returns {string}
 */
export const getRelicUserType = isLoggedIn => isLoggedIn ? 'member' : 'guest';

/**
 * @name getRelicConsent
 * @description - Returns consent from Cookies for Relic events
 * @returns {string}
 */
export const getRelicConsent = () => Cookies.get(NI_C_COOKIES) || '';
export const getRelicGeolocation = () => Cookies.get('geoloc') || '';
export const getRelicRegisteredCountry = async isLoggedIn => {
  var _await$window$webShel, _window$webShellClien, _window$webShellClien2, _window$webShellClien3;
  return isLoggedIn ? (_await$window$webShel = await ((_window$webShellClien = window.webShellClient) === null || _window$webShellClien === void 0 ? void 0 : (_window$webShellClien2 = _window$webShellClien.identity) === null || _window$webShellClien2 === void 0 ? void 0 : (_window$webShellClien3 = _window$webShellClien2.getUserProfile) === null || _window$webShellClien3 === void 0 ? void 0 : _window$webShellClien3.call(_window$webShellClien2))) === null || _await$window$webShel === void 0 ? void 0 : _await$window$webShel.registeredCountry : '';
};

/**
 * @name getRelicActionName
 * @description - Returns Relic event name based on event type
 * @param {string | undefined} actionType - Action type for the event that happened
 * @returns {string | undefined}
 */
export const getRelicActionName = actionType => {
  switch (actionType) {
    case RELIC_ACTION_TYPES_NAME.SETTINGS_PAGE_VIEWED:
      return RELIC_EVENT_NAME.PRIVACY_SETTINGS_VIEWED;
    case RELIC_ACTION_TYPES_NAME.ACCEPT_ALL_CLICKED:
      return RELIC_EVENT_NAME.PRIVACY_SETTINGS_ACCEPT_ALL;
    case RELIC_ACTION_TYPES_NAME.DECLINE_ALL_CLICKED:
      return RELIC_EVENT_NAME.PRIVACY_SETTINGS_DECLINE_ALL;
    case RELIC_ACTION_TYPES_NAME.CONFIRM_CHOICE_CLICKED:
      return RELIC_EVENT_NAME.PRIVACY_SETTINGS_CONFIRM_CHOICES;
    case RELIC_ACTION_TYPES_NAME.GPC_ENABLED:
      return RELIC_EVENT_NAME.GPC_ENABLED;
    default:
      return undefined;
  }
};